/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubVenueUpdateRequestDto as DigiworkMaitreDPosDtoAdvertiserSubVenueUpdateRequestDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Advertiser/sub-venue-update-request-dto';

export interface UpdateSubVenue$Params {
      body?: DigiworkMaitreDPosDtoAdvertiserSubVenueUpdateRequestDto
}

export function updateSubVenue(http: HttpClient, rootUrl: string, params?: UpdateSubVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSubVenue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSubVenue.PATH = '/api/gmn/Venue/updatesubvenue';
